module.exports = __webpack_public_path__ + "static/media/virusweb.a7cfe2f8.png";